@if (isLoading()) {
  <div class="table" role="status" aria-label="Carregando alertas" [appSkeleton]="true">
    <div class="table-scroll">
      <div class="table-row table-head" role="row">
        <span>Nome</span>
        <span>Alvo</span>
        <span>Quando</span>
        <span>Pessoas</span>
        <span>Status</span>
      </div>
      <div class="table-body">
        @for (row of skeletonRows; track row) {
          <div class="table-row" aria-hidden="true">
            <span class="cell-text cell-strong">Nome do alerta</span>
            <span class="cell-text">Fonte e dataset</span>
            <span class="cell-text">Freshness</span>
            <span class="cell-text">nome@empresa.com.br</span>
            <span class="cell-status">
              <span class="status-pill">Ativo</span>
            </span>
          </div>
        }
      </div>
    </div>
  </div>
} @else if (!alerts().length) {
  <empty-state
    title="Nenhum alerta cadastrado">
  </empty-state>
} @else {
  <div class="table" role="table">
    <div class="table-scroll">
    <div class="table-row table-head" role="row">
      <span class="head-cell">
        Nome
        <button
          type="button"
          class="head-filter"
          [class.active]="hasFilter('name')"
          [matMenuTriggerFor]="nameFilter"
          aria-label="Filtrar nome">
          <mat-icon svgIcon="new-filter"></mat-icon>
        </button>
        <mat-menu #nameFilter="matMenu" panelClass="alert-filter-menu" overlayPanelClass="alert-filter-menu">
          <div class="filter-list" (click)="keepMenuOpen($event)">
            @for (option of nameFilterOptions(); track option) {
              <label class="filter-option">
                <input type="checkbox" [checked]="isFilterSelected('name', option)" (change)="toggleFilter('name', option)" />
                <span>{{ option }}</span>
              </label>
            }
            @if (hasFilter('name')) {
              <div class="filter-footer">
                <button
                  type="button"
                  class="filter-clear"
                  aria-label="Limpar filtro"
                  matTooltip="Limpar filtro"
                  matTooltipPosition="above"
                  matTooltipClass="induxtry-tooltip"
                  (click)="clearFilter('name')">
                  <mat-icon svgIcon="not-filter"></mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      </span>
      <span class="head-cell">
        Alvo
        <button
          type="button"
          class="head-filter"
          [class.active]="hasFilter('target')"
          [matMenuTriggerFor]="targetFilter"
          aria-label="Filtrar alvo">
          <mat-icon svgIcon="new-filter"></mat-icon>
        </button>
        <mat-menu #targetFilter="matMenu" panelClass="alert-filter-menu" overlayPanelClass="alert-filter-menu">
          <div class="filter-list" (click)="keepMenuOpen($event)">
            @for (option of targetFilterOptions(); track option) {
              <label class="filter-option">
                <input type="checkbox" [checked]="isFilterSelected('target', option)" (change)="toggleFilter('target', option)" />
                <span>{{ option }}</span>
              </label>
            }
            @if (hasFilter('target')) {
              <div class="filter-footer">
                <button
                  type="button"
                  class="filter-clear"
                  aria-label="Limpar filtro"
                  matTooltip="Limpar filtro"
                  matTooltipPosition="above"
                  matTooltipClass="induxtry-tooltip"
                  (click)="clearFilter('target')">
                  <mat-icon svgIcon="not-filter"></mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      </span>
      <span class="head-cell">
        Quando
        <button
          type="button"
          class="head-filter"
          [class.active]="hasFilter('when')"
          [matMenuTriggerFor]="whenFilter"
          aria-label="Filtrar quando">
          <mat-icon svgIcon="new-filter"></mat-icon>
        </button>
        <mat-menu #whenFilter="matMenu" panelClass="alert-filter-menu" overlayPanelClass="alert-filter-menu">
          <div class="filter-list" (click)="keepMenuOpen($event)">
            @for (option of whenFilterOptions(); track option) {
              <label class="filter-option">
                <input type="checkbox" [checked]="isFilterSelected('when', option)" (change)="toggleFilter('when', option)" />
                <span>{{ option }}</span>
              </label>
            }
            @if (hasFilter('when')) {
              <div class="filter-footer">
                <button
                  type="button"
                  class="filter-clear"
                  aria-label="Limpar filtro"
                  matTooltip="Limpar filtro"
                  matTooltipPosition="above"
                  matTooltipClass="induxtry-tooltip"
                  (click)="clearFilter('when')">
                  <mat-icon svgIcon="not-filter"></mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      </span>
      <span class="head-cell">
        Pessoas
        <button
          type="button"
          class="head-filter"
          [class.active]="hasFilter('people')"
          [matMenuTriggerFor]="peopleFilter"
          aria-label="Filtrar pessoas">
          <mat-icon svgIcon="new-filter"></mat-icon>
        </button>
        <mat-menu #peopleFilter="matMenu" panelClass="alert-filter-menu" overlayPanelClass="alert-filter-menu">
          <div class="filter-list" (click)="keepMenuOpen($event)">
            @for (option of peopleFilterOptions(); track option) {
              <label class="filter-option">
                <input type="checkbox" [checked]="isFilterSelected('people', option)" (change)="toggleFilter('people', option)" />
                <span>{{ option }}</span>
              </label>
            }
            @if (hasFilter('people')) {
              <div class="filter-footer">
                <button
                  type="button"
                  class="filter-clear"
                  aria-label="Limpar filtro"
                  matTooltip="Limpar filtro"
                  matTooltipPosition="above"
                  matTooltipClass="induxtry-tooltip"
                  (click)="clearFilter('people')">
                  <mat-icon svgIcon="not-filter"></mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      </span>
      <span class="head-cell">
        Status
        <button
          type="button"
          class="head-filter"
          [class.active]="hasFilter('status')"
          [matMenuTriggerFor]="statusFilter"
          aria-label="Filtrar status">
          <mat-icon svgIcon="new-filter"></mat-icon>
        </button>
        <mat-menu #statusFilter="matMenu" panelClass="alert-filter-menu" overlayPanelClass="alert-filter-menu">
          <div class="filter-list" (click)="keepMenuOpen($event)">
            @for (option of statusFilterOptions(); track option) {
              <label class="filter-option">
                <input type="checkbox" [checked]="isFilterSelected('status', option)" (change)="toggleFilter('status', option)" />
                <span>{{ option }}</span>
              </label>
            }
            @if (hasFilter('status')) {
              <div class="filter-footer">
                <button
                  type="button"
                  class="filter-clear"
                  aria-label="Limpar filtro"
                  matTooltip="Limpar filtro"
                  matTooltipPosition="above"
                  matTooltipClass="induxtry-tooltip"
                  (click)="clearFilter('status')">
                  <mat-icon svgIcon="not-filter"></mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-menu>
      </span>
    </div>
    <div class="table-body">
    @for (alert of filteredAlerts(); track alert._id) {
      <div
        class="table-row"
        role="button"
        tabindex="0"
        [class.row-disabled]="!isEnabled(alert)"
        [attr.aria-label]="'Editar alerta ' + alert.name"
        (click)="openEdit(alert)"
        (keydown.enter)="openEdit(alert)"
        (keydown.space)="$event.preventDefault(); openEdit(alert)">
        <span
          class="cell-text cell-strong"
          [matTooltip]="alert.name"
          matTooltipPosition="above"
          matTooltipClass="induxtry-tooltip"
          #nameTip="matTooltip"
          (mouseenter)="syncCellTooltip($event, nameTip)">
          {{ alert.name }}
        </span>
        <span
          class="cell-text"
          [matTooltip]="targetTitle(alert)"
          matTooltipPosition="above"
          matTooltipClass="induxtry-tooltip"
          #targetTip="matTooltip"
          (mouseenter)="syncCellTooltip($event, targetTip, isTargetAbbreviated(alert))">
          {{ targetNames(alert) }}
        </span>
        <span class="cell-when">
          @if (alert.kind === 'freshness') {
            <span class="cell-text">Freshness</span>
            <span
              class="when-clock"
              [matTooltip]="freshnessScheduleLabel(alert)"
              matTooltipPosition="above"
              matTooltipClass="induxtry-tooltip"
              [attr.aria-label]="'Periodicidade: ' + freshnessScheduleLabel(alert)"
              (click)="$event.stopPropagation()">
              <icon-induxtry [icon]="{icon: 'clock', width: 16, height: 16, fill: '#575C66'}"></icon-induxtry>
            </span>
          } @else {
            <span
              class="cell-text"
              [matTooltip]="triggerLabel(alert)"
              matTooltipPosition="above"
              matTooltipClass="induxtry-tooltip"
              #whenTip="matTooltip"
              (mouseenter)="syncCellTooltip($event, whenTip)">
              {{ triggerLabel(alert) }}
            </span>
          }
        </span>
        <span
          class="cell-text"
          [matTooltip]="recipientTitle(alert)"
          matTooltipPosition="above"
          matTooltipClass="induxtry-tooltip"
          #peopleTip="matTooltip"
          (mouseenter)="syncCellTooltip($event, peopleTip, isRecipientAbbreviated(alert))">
          {{ recipientLabel(alert) }}
        </span>
        <span class="cell-status">
          <span class="status-pill" [class.status-pill--off]="!isEnabled(alert)">
            {{ statusLabel(alert) }}
          </span>
        </span>
      </div>
    }
    </div>
    </div>
  </div>
  @if (!filteredAlerts().length) {
    <p class="panel-subtitle">Nenhum alerta corresponde aos filtros.</p>
  }
}

<button
  type="button"
  class="fab-create"
  aria-label="Novo alerta"
  matTooltip="Novo alerta"
  matTooltipPosition="left"
  matTooltipClass="induxtry-tooltip"
  (click)="openCreate()">
  <icon-induxtry [icon]="{icon: 'Plus', width: 24, height: 24, stroke: '#FFFFFF'}"></icon-induxtry>
</button>
